import { UpdateNotificationType } from './update-notification-type';

export class UpdateNotificationBaseDto {
  updateType: UpdateNotificationType;
}

export class UpdateNotificationMarkAllAsReadDto extends UpdateNotificationBaseDto {
  constructor() {
    super();
    this.updateType = UpdateNotificationType.MarkAllAsRead;
  }
}

export class UpdateNotificationMarkItemsAsReadDto extends UpdateNotificationBaseDto {
  notificationIds: string[];
  constructor() {
    super();
    this.updateType = UpdateNotificationType.MarkItemsAsRead;
  }
}
